import type { StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { css } from '@repo/pandacss/styled-system/css';
import Image from 'next/image';
import { SPOTLIGHT_SPARKLE_SVG } from './constants';

export type SpotlightTitleProps = {
  title?: string;
  details?: StructuredContentDocument;
};

const titleBarStyles = css({
  backgroundColor: 'green.darkest',
  borderTopLeftRadius: 'lg',
  borderTopRightRadius: 'lg',
  paddingInlineStart: '3.5',
  paddingInlineEnd: '3.5',
  paddingTop: '4',
  paddingBottom: '4',
  display: 'flex',
  alignItems: 'center',
  justifyContent: { base: 'center', md: 'flex-start' },
});

const titleTextStyles = css({
  display: 'flex',
  alignItems: 'center',
  columnGap: '1',
  rowGap: '1',
  color: 'green.extraLight',
  fontSize: 'xl',
  fontWeight: 'medium',
  textAlign: { base: 'center', md: 'left' },
});

const sparkleStyles = css({
  width: { base: '4', md: '5' },
  height: { base: '4', md: '5' },
  flexShrink: '0',
});

export const SpotlightTitle = ({ title, details }: SpotlightTitleProps) => {
  if (!title || !details) {
    return null;
  }

  return (
    <div className={titleBarStyles} data-testid="spotlight-title">
      <p className={titleTextStyles}>
        <Image
          src={SPOTLIGHT_SPARKLE_SVG}
          alt=""
          width={20}
          height={21}
          unoptimized
          className={sparkleStyles}
        />
        {title}
      </p>
    </div>
  );
};
